module.exports = __webpack_public_path__ + "static/pod-believe-37346029e8817f5242ca2a5c00a79c7a.jpg";